import React from 'react';
import 'twin.macro';
import SearchEtablissement from 'containers/MesAnneesScolaires/SearchEtablissement';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import { useUpdateDemarrage } from 'containers/Demarrage/queries/useUpdateDemarrage';
import { Divider } from 'components/Divider';
import Button from 'components/Buttons/Button';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { DemarrageData } from 'containers/Demarrage/types';

interface Props {
  demarrageData: DemarrageData;
  onManual: () => void;
}

export function FREcoleStep(props: Props) {
  const { demarrageData, onManual } = props;
  const update = useUpdateDemarrage();
  const { t } = useTranslation(['onboarding', 'schoolyearSettings']);
  return (
    <StepWrapper
      title={t('onboarding:school.title')}
      currentStep="ecole"
      nextDisabled={!demarrageData.etablissementUai}
    >
      <p tw="mb-2 text-base">{t('onboarding:school.description')}</p>
      <p tw="mb-4 text-base">{t('onboarding:school.description2')}</p>
      <SearchEtablissement
        size="lg"
        country="FR"
        helperText={t(
          'schoolyearSettings:schoolGeneral.searchSchool.inputLabel',
        )}
        onManual={onManual}
        onSelect={async ({ selectedEtablissement, query, nbResults }) => {
          await update({
            etablissementUai: selectedEtablissement?.id,
            searchQueries: [
              ...(demarrageData?.searchQueries || []),
              { query, nbResults },
            ],
          });
        }}
        selectedEtablissementId={demarrageData?.etablissementUai}
      />

      {(demarrageData?.userRoles?.includes('autre') ||
        demarrageData?.userRoles?.includes('2nd degré')) && (
        <>
          <Divider
            bgColor="gray-100"
            tw="my-8"
            title={t('onboarding:school.or')}
          />
          <div tw="text-center">
            <Button
              onClick={onManual}
              extralarge
              outlined
              rightIcon={ArrowRight}
            >
              {t('onboarding:school.goManually')}
            </Button>
          </div>
        </>
      )}
    </StepWrapper>
  );
}
